import { getCalendarEventsLoadState } from 'owa-calendar-surface-calendars-store';
import { getCalendarFolderIdUpdateLoadState } from 'owa-calendarsapi-outlook';

/**
 * Get the overall load state for a calendar. This takes into account the loading status
 * of events in the date range locked by the calendar surface store's lock instance as well as
 * the loading status of requests to update calendar folder ids (if applicable - see getAndUpdateActualFolderId for details).
 * @param calendarId calendarId
 */
export function getCalendarLoadState(calendarId: string) {
    const calendarFolderIdUpdateLoadState = getCalendarFolderIdUpdateLoadState(calendarId);
    const calendarEventsLoadState = getCalendarEventsLoadState(calendarId);
    // Calendar events can only be loaded once that the calendar folder id is updated, so,
    // we can assume if we have a load state for the calendar events the calendar folder id is updated.
    return calendarEventsLoadState ? calendarEventsLoadState : calendarFolderIdUpdateLoadState;
}
